import { combineReducers } from 'redux';
import { takeEvery, call } from 'redux-saga/effects';
import actionKey from '../utils/action-key';
import request from '../api-utils/request';

const FETCH_INDUSTRIES = 'sites/FETCH_INDUSTRIES';

const industriesListReducer = (state = [], action) => {
    switch (action.type) {
        case actionKey.success(FETCH_INDUSTRIES):
            return action.payload.industries;
        default:
            return state;
    }
};

const loadingReducer = (state = false, action) => {
    switch (action.type) {
        case FETCH_INDUSTRIES:
            return true;
        case actionKey.failure(FETCH_INDUSTRIES):
        case actionKey.success(FETCH_INDUSTRIES):
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    industriesList: industriesListReducer,
    loading: loadingReducer,
});

export const fetchIndustriesAction = () => ({
    type: FETCH_INDUSTRIES,
});

export function* rootSaga() {
    yield [
        takeEvery(FETCH_INDUSTRIES, fetchIndustries),
    ];
}

function* fetchIndustries({ type }) {
    yield call(request, {
        url: '/api/industry',
        type,
        options: {
            method: 'GET',
        },
    });
}



// WEBPACK FOOTER //
// ./src/client/redux/industries.js